// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-item__body{max-height:612px!important;overflow-x:hidden!important}.el-scrollbar__bar.is-horizontal{display:none}.attestation-popper .popper__arrow{display:block!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
